import React from "react";
import { useParams } from "react-router-dom";
import ProductGrid from "./home/ProductGrid";
import SEO from "./SEO";

const ShopAll = () => {
  const { categoryId, categoryName } = useParams(); // 👈 Get category name + id

  return (
    <div>
            <SEO
                    title='Shirts Patches shop All Product'
                    description='Shirts Patches'
                    keywords='Shirts Patches'
                  />
<ProductGrid categoryId="allproducts" categoryName="All Products" />      
    </div>
  );
};

export default ShopAll;
